module.exports = __webpack_public_path__ + "files/fe807547b299e44c23545c1a9eaa8ecd.png";